import Swal from 'sweetalert2';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const DeleteItemAlert = (
  confirmAction: () => Promise<any>,
  message?: string
) => {
  return MySwal.fire({
    title: <ReturnTranslatedText text={`general.${'Are you sure?'}`} />,
    html: (
      <div>
        <ReturnTranslatedText
          text={`general.${message}`}
          origintext={message || ''}
        />
        {message && <br />}
        <ReturnTranslatedText
          text={`general.${"You won't be able to revert this!"}`}
        />
      </div>
    ),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: (
      <ReturnTranslatedText text={`general.${'Yes, delete it!'}`} />
    ),
    cancelButtonText: <ReturnTranslatedText text={`general.${'Cancel'}`} />,
  }).then((result) => {
    if (result.isConfirmed) {
      confirmAction();
    }
  });
};
